import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const AuthRoute = ({ component: Component, authenticated, loading, rootActive, adminActive, shopmanagerActive, ...rest }) => (
    <Route
    {...rest}
    render={(props) => {
        const check_active = rootActive === true || adminActive === true || shopmanagerActive === true;
        if(authenticated === true) {
            if(loading === false) {
                if(check_active) {
                    return <Redirect to='/' />;
                } else {
                    return window.location='https://nteashop.vn/';
                }
            }
        } else {
            return <Component {...props} />;    
        }
    }}
    />
)

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
    loading: state.user.loading,
    rootActive: state.user.credentials.rootActive,
    adminActive: state.user.credentials.adminActive,
    shopmanagerActive: state.user.credentials.shopmanagerActive,
})

AuthRoute.propTypes = {
    user: PropTypes.object
};

export default connect(mapStateToProps)(AuthRoute);